export default function PageLoader() {
    return (
        <div className="flex items-center justify-center min-h-[50vh]">
            <div className="h-8 w-8 animate-spin rounded-full border-3 border-solid border-brand-500 border-t-transparent" />
        </div>
    );
}
